import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink } from '@plone/volto/components';
import { Image } from 'semantic-ui-react';
import { FormattedDate } from '@plone/volto/components';
import FadeInSection from '../../../theme/Animations/FadeInSection';
import { flattenToAppURL } from '@plone/volto/helpers';

const HomepageNewsKacheln = ({ items, isEditMode }) => {
  const shortenString = (str, maxLength) => {
    if (!str) return '';
    if (str.length <= maxLength) return str;
    let shortenedStr = str.substring(0, maxLength);
    shortenedStr = shortenedStr.substr(0, Math.min(shortenedStr.length, shortenedStr.lastIndexOf(" ")));
    return shortenedStr + ' ...';
  };

  const getColor = (index) => {
    if (index % 4 === 0) return 'darkblue';
    if (index % 4 === 1) return 'blau';
    if (index % 4 === 2) return 'grün';
    return 'weiß';
  };

  const getDate = (item) => {
    if (item['@type'] === "Event" && item.start) {
      return String(item.start);
    }
    return item.effective;
  }

  return (
    <section className="homepage-news-template" aria-label="Latest News" role="list">
      <div className="ui twelve column grid column-grid">
        {items.map((item, index) => (

          <article
            key={index}
            className="four wide computer twelve wide mobile six wide tablet column column-blocks-wrapper"
            role="listitem"
            aria-labelledby={`news-title-${index}`}
          >
            <FadeInSection>
              <ConditionalLink item={item} condition={!isEditMode}>
                <div
                  className={`kachel ${getColor(index)}`}
                  role="article"
                  aria-label={`News item: ${item.title}`}
                  tabIndex={!isEditMode ? 0 : undefined}
                >
                  {item.image && (
                    <Image
                      src={flattenToAppURL(item.image.scales.teaser.download)}
                      alt={item.alt || item.title || ''}
                      aria-hidden={!(item.alt || item.title)}
                    />
                  )}
                  {!item.image && item.preview_image && (
                    <Image
                      src={flattenToAppURL(item.preview_image.scales.teaser.download)}
                      alt={item.preview_caption || item.title || ''}
                      aria-hidden={!(item.preview_caption || item.title)}
                    />
                  )}

                  <div className="listing-kachel">
                    <h3 id={`news-title-${index}`}>{item.title ? shortenString(item.title, 50) : item.id}</h3>
                    {item.description && <p>{shortenString(item.description, 110)}</p>}
                    {item.effective && (
                      <p className="datum">
                        <FormattedDate date={getDate(item)} />
                      </p>
                    )}
                  </div>
                </div>
              </ConditionalLink>
            </FadeInSection>

          </article>

        ))}
      </div>
    </section>
  );
};

HomepageNewsKacheln.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isEditMode: PropTypes.bool,
};

export default HomepageNewsKacheln;
